export default __webpack_public_path__ + "static/media/4_slide.10fa7a84.png";